import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="La Viuda De Mi Vecina Capítulo 20– Rose Blue 3D"
      portada="https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-01.webp"
    paginas={[
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-01.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-02.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-03.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-04.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-05.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-06.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-07.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-08.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-09.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-10.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-11.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-12.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-13.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-14.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-15.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-16.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-17.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-18.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-19.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-20.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-21.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-22.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-23.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-24.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-25.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-26.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-27.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-28.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-29.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-30.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-31.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-32.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-33.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-34.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-35.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-36.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-37.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-38.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-39.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-40.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-41.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-42.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-43.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-44.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-45.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-46.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-47.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-48.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-49.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-50.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-51.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-52.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-53.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-54.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-55.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-56.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-57.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-58.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-59.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-60.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-61.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-62.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-63.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-64.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-65.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-66.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-67.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-68.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-69.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-70.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-71.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-72.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-73.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-74.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-75.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-76.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-77.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-78.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-79.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-80.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-81.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-82.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-83.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-84.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-85.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-86.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-87.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-88.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-89.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-90.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-91.webp",
  "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-92.webp"
]}
      sugeridos={[]}


      info={{
       grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 20– Rose Blue 3D",
  portada: "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-01.webp",
  reverso: "https://reycomix.com/wp-content/uploads/2024/06/My-Neighbors-Widow-20-RoseBlue3D-04.webp",
   fecha:"2026-05-17",


  info: {
    grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
  },
};
